const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";
const ARABIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";

export function normalizeDigits(text) {
  return String(text ?? "")
    .replace(/[۰-۹]/g, (digit) => PERSIAN_DIGITS.indexOf(digit))
    .replace(/[٠-٩]/g, (digit) => ARABIC_DIGITS.indexOf(digit));
}

export function parseTimePart(text, max) {
  const digits = normalizeDigits(text).replace(/\D/g, "").slice(0, 2);
  if (digits === "") return null;
  const value = Number(digits);
  if (!Number.isInteger(value)) return null;
  return Math.min(Math.max(value, 0), max);
}

export function padTimePart(value) {
  return String(value).padStart(2, "0");
}

export function withTimePart(date, part, value) {
  const next =
    date instanceof Date && !Number.isNaN(date.getTime())
      ? new Date(date.getTime())
      : new Date();
  if (part === "hour") next.setHours(value);
  else next.setMinutes(value);
  return next;
}
